module.exports = "<p-messages [value]=\"messages\"></p-messages>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/error/error.html
 ** module id = 805
 ** module chunks = 0
 **/